import React, { useEffect } from 'react';
import { TopCountdownBar } from './components/TopCountdownBar';
import { Hero } from './components/Hero';
import { MirrorSection } from './components/MirrorSection';
import { ReframeSection } from './components/ReframeSection';
import { ArsenalSection } from './components/ArsenalSection';
import { PricingTable } from './components/PricingTable';
import { Testimonials } from './components/Testimonials';
import { GuaranteeSection } from './components/GuaranteeSection';
import { FAQSection } from './components/FAQSection';
import { Footer } from './components/Footer';
import { FloatingBottomCTA } from './components/FloatingBottomCTA';
import { initFacebookPixel, trackViewContent } from './utils/facebook-pixel';
export function App() {
  useEffect(() => {
    initFacebookPixel();
    trackViewContent();
  }, []);
  return <div className="pt-12 overflow-x-hidden pb-16" data-id="element-0">
      <TopCountdownBar data-id="element-1" />
      <main data-id="element-2">
        <Hero data-id="element-3" />
        <MirrorSection data-id="element-4" />
        <ReframeSection data-id="element-5" />
        <ArsenalSection data-id="element-6" />
        <PricingTable data-id="element-7" />
        <Testimonials data-id="element-8" />
        <FAQSection data-id="element-9" />
        <GuaranteeSection data-id="element-10" />
      </main>
      <Footer data-id="element-11" />
      <FloatingBottomCTA data-id="element-12" />
    </div>;
}